import RegisteredTrademarkIcon from './component'

export default RegisteredTrademarkIcon